import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CContainer, CHeader, CHeaderBrand, CHeaderDivider, CHeaderNav, CHeaderToggler, CNavLink, CNavItem, } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilEnvelopeOpen, cilList, cilMenu } from '@coreui/icons'
import { VendorReducer } from 'shared/redux/reducers/vendor/VendorReducer'
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import style from "./PartnersHeader.module.css";
import ManagerBreadcrumb from "components/manager/ManagerBreadcrumb"

const PartnersHeader = () => {
    const { isMobile } = useContext(BrowserDetectContext);
    const dispatch = useDispatch();
    // const sidebarShow = useSelector((state) => state.sidebarShow)
    const { sidebarShow } = useSelector((state) => ({ sidebarShow: state.vendor.sidebarShow }));

    const onSidebarTogglerClick = () => {
        dispatch(VendorReducer.actions.toggleSideBar(!sidebarShow));
    }

    return (
        <CHeader position="sticky">
            <CContainer fluid>
                {
                    isMobile ?
                        <>
                            <CHeaderToggler className="ps-1" onClick={onSidebarTogglerClick} >
                                <CIcon icon={cilMenu} size="lg" />
                            </CHeaderToggler>
                            <CHeaderBrand className="mx-auto d-md-none" to="/">
                                로고자리
                            </CHeaderBrand>
                            <div style={{ width: "36px", height: "38px" }}>

                            </div>
                        </>
                        :
                        <div>
                            로고자리
                        </div>
                }
            </CContainer>
            {
                !isMobile &&
                <>
                    <CHeaderDivider />
                    <CContainer fluid>
                        <ManagerBreadcrumb />
                    </CContainer>
                </>

            }

        </CHeader>
    )
}

export default PartnersHeader
